import React from 'react';
import PropTypes from 'prop-types';
import { List } from './list';
import { MENU, NONE } from '../../modules/constants';

/**
 * Some of the sub menu lists are grouped under a title, this provides that title.
 *
 * @function
 * @param       {string} className         An optional class to add to the existing component class attribute.
 * @param       {string} text              The text of the link.
 * @param       {boolean} inList           If we are already in a list, this will be true and force the omission of the opening ul tag.
 * @param       {array}  children          An optional collection of menu items
 * @constructor
 */
function Title({ className, text, inList, children }) {
    function ListTitle() {
        return (
            <>
                {children && children.length ? (
                    <>
                        <h4 className={className}>{text}</h4>
                        <List text={text} role={MENU}>
                            {children}
                        </List>
                    </>
                ) : (
                    <h4 className={className}>{text}</h4>
                )}
            </>
        );
    }
    if (inList) {
        return (
            <li role={NONE}>
                <ListTitle />
            </li>
        );
    }

    return <ListTitle />;
}

Title.propTypes = {
    className: PropTypes.string,
    text: PropTypes.string,
    inList: PropTypes.bool,
    children: PropTypes.array
};

export { Title };
